import axios from "axios";

import config from "../config";

export default class UserService {
  static getFarmerProfile = (mobile) => {
    return axios.get(
      `${config.crmServiceUrl}farmerdetails/basic/?phoneNumber=${mobile}`,
      {
        headers: {
          "X-Authorization-Token": config.crmXAuthToken,
          Source: "CSR",
        },
      }
    );
  };
  static signup = (name, mobile, state, userSource) => {
    return axios.put(`${config.baseUrl}/user/signup `, {
      name: name,
      mobile: mobile,
      state: state,
      user_source: userSource,
    });
  };

  static login = (name, mobile, rememberMe = true) => {
    return axios.post(`${config.baseUrl}/user/login`, { mobile: mobile });
  };

  static saveUser = (
    name,
    mobile,
    state,
    rememberMe = true,
    premium = false,
    isNew = false,
    userSource = "WEB",
    languageCode="mr"
  ) => {
    if (rememberMe === true) {
      localStorage.setItem("name", name);
      localStorage.setItem("mobile", mobile);
      localStorage.setItem("state", state);
      localStorage.setItem("premium", premium);
      localStorage.setItem("isNew", isNew);
      localStorage.setItem("userSource", userSource);
      localStorage.setItem("languageCode", languageCode);
    } else {
      sessionStorage.setItem("name", name);
      sessionStorage.setItem("mobile", mobile);
      sessionStorage.setItem("state", state);
      sessionStorage.setItem("premium", premium);
      sessionStorage.setItem("isNew", isNew);
      sessionStorage.setItem("userSource", userSource);
      sessionStorage.setItem("languageCode", languageCode);
    }
  };

  static updateUserSource = (userSource = "WEB") => {
    localStorage.setItem("userSource", userSource);
    sessionStorage.setItem("userSource", userSource);
  };

  static sendOtp = (mobile) => {
    return axios.get(`${config.otpServiceUrl}?phoneNumber=${mobile}`);
  };

  static verifyOtp = (otp, otpToken) => {
    return axios.post(`${config.otpServiceUrl}`, {
      otp: otp,
      otpToken: otpToken,
    });
  };

  static saveOtpVerification = (mobile, otpVerificationStatus) => {
    return axios.post(`${config.baseUrl}/user/verify-otp`, {
      mobile: mobile,
      otp_verified: otpVerificationStatus,
    });
  };

  static checkPremium = () => {
    let user = this.getUserInfo();
    if (user && user.premium === "true") {
      return true;
    } else {
      return false;
    }
  };
  static checkUserLogin = () => {
    let user = this.getUserInfo();
    if (user && user.mobile && user.mobile !== "") {
      return true;
    } else {
      return false;
    }
  };
  static getUserInfo = () => {
    if (localStorage.getItem("mobile")) {
      return {
        name: localStorage.getItem("name"),
        mobile: localStorage.getItem("mobile"),
        state: localStorage.getItem("state") || "maharashtra",
        premium: localStorage.getItem("premium"),
        isNew: localStorage.getItem("isNew"),
        userSource: localStorage.getItem("userSource"),
      };
    } else if (sessionStorage.getItem("mobile")) {
      return {
        name: sessionStorage.getItem("name"),
        mobile: sessionStorage.getItem("mobile"),
        state: sessionStorage.getItem("state") || "maharashtra",
        premium: sessionStorage.getItem("premium"),
        isNew: sessionStorage.getItem("isNew"),
        userSource: sessionStorage.getItem("userSource"),
      };
    } else {
      return false;
    }
  };

  static getUser = () => {
    let { mobile } = this.getUserInfo();
    return axios.get(`${config.baseUrl}/users/${mobile}`);
  };

  static logUser = () => {
    const skipLogging = false;
    if (!skipLogging) {
      window.setTimeout(() => {
        let { name, mobile, state } = this.getUserInfo();

        if (mobile) {
          let userRecord = {
            name: name,
            mobile: mobile,
            state: state,
            timestamp: Date.now(),
          };

          axios.post(`${config.baseUrl}/user/log`, userRecord);
        }
      }, 200);
    }
  };

  static logVideoplay = (cropName, authorName, week, topic, language) => {
    const skipLogging = false;
    if (!skipLogging) {
      window.setTimeout(() => {
        let { name, mobile, state } = this.getUserInfo();

        if (mobile) {
          let record = {
            name: name,
            mobile: mobile,
            stateName: state,
            cropName: cropName,
            authorName: authorName,
            languageCode: language,
            week: week,
            sessionTopic: topic,
            timestamp: Date.now(),
          };

          axios.post(`${config.baseUrl}/user/logvideoplay`, record);
        }
      }, 200);
    }
  };

  static logout = () => {
    localStorage.removeItem("name");
    localStorage.removeItem("mobile");
    localStorage.removeItem("state");
    localStorage.removeItem("languageCode");
    localStorage.removeItem("premium");
    localStorage.removeItem("isNew");
    localStorage.removeItem("userSource");

    sessionStorage.removeItem("name");
    sessionStorage.removeItem("mobile");
    sessionStorage.removeItem("state");
    sessionStorage.removeItem("languageCode");
    sessionStorage.removeItem("premium");
    sessionStorage.removeItem("isNew");
    sessionStorage.removeItem("userSource");
  };
}
